import { CONFIG } from 'constants/index';
import { ApiResponse } from 'endpoints/endpoint';
import { renameFile } from 'utils/index';
import { lead } from 'endpoints/index';

import api from '..';

export const leadApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createLead: builder.mutation<ApiResponse<lead.CreateResult, lead.CreateError>, lead.CreateParams>({
      queryFn: (params) => {
        return new Promise((resolve, reject) => {
          const formData = new FormData();

          if (params.fallenName) formData.append('fallenName', params.fallenName);
          if (params.fullName) formData.append('fullName', params.fullName);
          if (params.email) formData.append('email', params.email);
          if (params.phone) formData.append('phone', params.phone);
          if (params.photoCredit) formData.append('photoCredit', params.photoCredit);
          if (params.songName) formData.append('songName', params.songName);
          if (params.story) formData.append('story', params.story);
          if (params.image && typeof params.image !== 'string')
            formData.append('image', renameFile(params.image, 'image'));
          if (params.connectionType) formData.append('connectionType', params.connectionType);
          if (typeof params.confirmation !== 'undefined')
            formData.append('confirmation', params.confirmation.toString());

          const request = new XMLHttpRequest();
          const { method, url } = lead.update(params).args;

          request.onload = () => {
            try {
              const response = JSON.parse(request.response);
              resolve({ data: response as ApiResponse<lead.CreateResult, lead.CreateError> });
            } catch (e) {
              reject(e);
            }
          };
          request.open(method, `${CONFIG.api}${url}`);
          request.onerror = () => {
            reject('Network error');
          };
          request.send(formData);
        });
      },
    }),
  }),
  overrideExisting: false,
});
